import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import StepAccount from './Register/StepAccount';
import StepProfile from './Register/StepProfile';
import StepOrganisation from './Register/StepOrganisation';

import {
  organisationAPI,
  login,
  createStripeSetupSession,
  completeRegister,
} from 'api/Accounts/AccountsAPI';

export default function RegisterWizard() {
  const [step, setStep] = useState(1);

  const [accountData, setAccountData] = useState<any>({});
  const [profileData, setProfileData] = useState<any>({});
  const [organisationData, setOrganisationData] = useState<any>({});

  const [error, setError] = useState<any>(null);

  const navigate = useNavigate();

  async function handleFinalSubmit({ org, account, profile }: any) {
    try {
      setError(null);

      await completeRegister({
        account: {
          username: account.username,
          email: account.email,
          password: account.password,
        },
        profile: {
          first_name: profile.first_name,
          last_name: profile.last_name,
          phone_number: profile.phone_number,
          department: profile.department,
          position_title: profile.position_title,
          role: profile.role,
          permissions: profile.permissions,
        },
        organisation: {
          name: org.name,
          description: org.description,
          account_type: 4,
          logo: org.logo,
          email: org.email,
          phone_number: org.phone_number,
          website: org.website,
          address: org.address,
          size_on_record: org.size_on_record,
          size_at_service: org.size_at_service,
          denomination: org.denomination,
        },
      });

      await login(account.username, account.password);

      const orgCreated = await organisationAPI.getByLoggedInUser();

      // const session = await createStripeSetupSession(orgCreated.id);
      // window.location.href = session.url;
      navigate('/accounts/organisation/');
      
    } catch (err: any) {
      const backendError = err.response?.data || { _form: "Registration failed" };
      setError(backendError);

      if (backendError.username || backendError.email || backendError.password) {
        setStep(1);
        return;
      }

      if (
        backendError.first_name ||
        backendError.last_name ||
        backendError.phone_number ||
        backendError.department ||
        backendError.position_title
      ) {
        setStep(2);
        return;
      }

      setStep(3);
    }
    
  }

  

  return (
    <>
      {step === 1 && (
        <StepAccount
          data={accountData}
          error={error}
          onNext={(d: any) => {
            setAccountData(d);
            setStep(2);
          }}
        />
      )}

      {step === 2 && (
        <StepProfile
          data={profileData}
          error={error}
          onNext={(d: any) => {
            setProfileData(d);
            setStep(3);
          }}
          onBack={() => setStep(1)}
        />
      )}

      {step === 3 && (
        <StepOrganisation
          data={organisationData}
          error={error}
          onNext={(d) => {
            setOrganisationData(d);
            handleFinalSubmit({
              org: d,
              account: accountData,
              profile: profileData,
            });
          }}
          onBack={() => setStep(2)}
        />
      )}
    </>
  );
}